export default __webpack_public_path__ + "static/media/active.f7e54331.svg";